export enum SideType {
  BACK = 1,
  LAY = 2,
  YES = 1,
  NO = 2
}

const sideTypeConst = Object.freeze({
  BACK: SideType.BACK,
  LAY: SideType.LAY,
  YES: SideType.YES,
  NO: SideType.NO
})

export default sideTypeConst
